// App.js
import React from 'react';
import { Route, Routes, Outlet } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Login from './pages/Login';
import CustomerDashboard from './pages/CustomerDashboard';
import CarrierDashboard from './pages/CarrierDashboard';
import NotificationsPage from './pages/NotificationsPage';
import ProtectedRoute from './components/ProtectedRoute';
import CarrierLoads from './pages/CarrierLoads';
import CustomerShipments from './pages/CustomerShipments';
import DriverManagement from './pages/DriverManagement';
import About from './pages/About';
import Contact from './pages/Contact';
import Services from './pages/Services';
import CustomerUserManagement from './pages/CustomerUserManagement';
import DispatcherManagement from './pages/DispatcherManagement';
import Analytics from './pages/Analytics';
import Billings from './pages/Billings';
import Settings from './pages/Settings';
import VehicleManagement from './pages/VehicleManagement';
import LoadTracking from './pages/LoadTracking';
import Register from './pages/Register';
import AdminDashboard from './pages/AdminDashboard';
import AdminLogin from './pages/AdminLogin';
import MessagingPage from './pages/MessagingPage';
import LoadPage from './pages/LoadPage';
import SetPasswordPage from './pages/SetPasswordPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import PaymentReviewPage from './pages/PaymentReviewPage';
import RealTimeOperations from './pages/RealTimeOperations';
import LoadManagement from './pages/LoadManagement';
import BillingAndDisputes from './pages/BillingAndDisputes';
import DocumentControls from './pages/DocumentControls';
import MobileApplications from './pages/MobileApplications';
import TelematicsIntegration from './pages/TelematicsIntegration';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import SecurityPolicy from './pages/SecurityPolicy';
import ConnectionStatusIndicator from './components/ConnectionStatusIndicator';

const PublicLayout = () => (
  <>
    <Navbar />
    <Outlet />
  </>
);

function App() {
  return (
    <>
      <ConnectionStatusIndicator />
      <Routes>
      {/* Public routes with Navbar */}
      <Route element={<PublicLayout />}>
        <Route index element={<Home />} />
        <Route path="register" element={<Register />} />
        <Route path="login" element={<Login />} />
        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />
        <Route path="services" element={<Services />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="terms-of-service" element={<TermsOfService />} />
        <Route path="security" element={<SecurityPolicy />} />
        
        {/* Feature pages */}
        <Route path="features">
          <Route path="real-time-operations" element={<RealTimeOperations />} />
          <Route path="load-management" element={<LoadManagement />} />
          <Route path="billing-&-disputes" element={<BillingAndDisputes />} />
          <Route path="document-control" element={<DocumentControls />} />
          <Route path="mobile-applications" element={<MobileApplications />} />
          <Route path="telematics-integration" element={<TelematicsIntegration />} />
        </Route>
      </Route>

      {/* Protected customer routes */}
      <Route
        path="customer"
        element={<ProtectedRoute allowedUserTypes={['customer', 'customer_admin']} />}
      >
        <Route index element={<CustomerDashboard />} />
        <Route path="dashboard" element={<CustomerDashboard />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route path="shipments" element={<CustomerShipments />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="settings" element={<Settings />} />
        <Route path="tracking" element={<LoadTracking />} />
        <Route path="messages" element={<MessagingPage />} />
      </Route>

      {/* Protected customer routes that require payment access */}
      <Route
        path="customer"
        element={<ProtectedRoute allowedUserTypes={['customer', 'customer_admin']} blockViewOnly={true} />}
      >
        <Route path="billings" element={<Billings />} />
      </Route>

      {/* Protected customer admin-only routes */}
      <Route
        path="customer"
        element={<ProtectedRoute allowedUserTypes={['customer_admin']} />}
      >
        <Route path="user-management" element={<CustomerUserManagement />} />
      </Route>

      {/* Protected carrier routes */}
      <Route
        path="carrier"
        element={<ProtectedRoute allowedUserTypes={['carrier', 'carrier_admin']} />}
      >
        <Route index element={<CarrierDashboard />} />
        <Route path="dashboard" element={<CarrierDashboard />} />
        <Route path="loads" element={<CarrierLoads />} />
        <Route path="billings" element={<Billings />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route path="drivers" element={<DriverManagement />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="settings" element={<Settings />} />
        <Route path="vehicles" element={<VehicleManagement />} />
        <Route path="tracking" element={<LoadTracking />} />
        <Route path="messages" element={<MessagingPage />} />
      </Route>

      {/* Protected carrier admin-only routes */}
      <Route
        path="carrier"
        element={<ProtectedRoute allowedUserTypes={['carrier_admin']} />}
      >
        <Route path="dispatcher-management" element={<DispatcherManagement />} />
      </Route>

      {/* Separate admin login route */}
      <Route path="admin/login" element={<AdminLogin />} />

      {/* Protected admin routes */}
      <Route
        path="admin"
        element={<ProtectedRoute allowedUserTypes={['system_admin']} />}
      >
        <Route index element={<AdminDashboard />} />
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="payments/:paymentId/review" element={<PaymentReviewPage />} />
      </Route>

      {/* Public load page route */}
      <Route path="loads/:loadId" element={<LoadPage />} />

      {/* Set password route */}
      <Route path="/set-password/:token" element={<SetPasswordPage mode="initial" />} />
      <Route path="/reset-password/:token" element={<SetPasswordPage mode="reset" />} />

      {/* Forgot password route */}
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
    </Routes>
    </>
  );
}

export default App;
